module.exports = "<div class=\"titled-container\">\n  <header>\n    <span><ng-content select=\"[left-header]\"></ng-content></span>\n    <span *ngIf=\"title\" class=\"title\">\n      <h5>{{title}}</h5>\n    </span>\n    <span><ng-content select=\"[right-header]\"></ng-content></span>\n  </header>\n  <div class=\"content\">\n    <ng-content select=\"[body]\"></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/titled-container/titled-container.component.html
// module id = 1541
// module chunks = 2